import React, { useEffect, useRef, useState } from 'react';
import { IonCol, IonButton, IonIcon, IonPopover, IonInput, IonItem, IonCardTitle, IonGrid, IonRow, IonSpinner, IonToast, IonActionSheet, IonLabel, IonAccordionGroup, IonAccordion } from '@ionic/react';
import { addCircleSharp, albumsOutline, checkmark, checkmarkDoneCircleSharp, closeCircleSharp, colorFillSharp, copy, enter, eye, eyeOff, gameController, gameControllerOutline, image, moveOutline, playCircle, schoolOutline, shapes, speedometerOutline, textOutline, trash } from 'ionicons/icons';
import { _ALIAS_SUFFIX, _NEW_LINE, _cachedLocalAutoL2image, _debugMode, _defaultButtonColor, _dict, _pathSeparator, _possibleCardColors, charsMappingFromURL } from './constants';
import { deleteLabelsFromNodes, deleteNodesWithPrefix, getProperSuffixDict, normalizeString, updateSimpleDictForKeys, updict } from './foo';
import { useHistory } from 'react-router';
import { Sound } from './useRecorder';
import { isYoutubeUrl, usePhotoGallery } from './usePhotoGallery';
import VoiceRecorder from './RecordButton';
import './SidebarEditCards.css';
import SearchModal from './dialogs/ImageLibrary';
import { ImageSelector } from './dialogs/ImageSelection';
import VideoPopover from './dialogs/VideoPopover';
import { useGlobalStore } from './stateManagement/globalZustand';
import { useTreeStore } from './stateManagement/treeZustand';
import { useURLStore } from './stateManagement/URLZustand';
import { useUIStore } from './stateManagement/UIZustand';
import { convertArrayToText, copyToClipboard } from '../foo/browser';


interface SidebarEditCardsProps {

}


function changeLabelInNodes(
  nodes: { [id: string]: string[] },
  currentPathStr: string,
  oldLabel: string,
  newLabel: string,
  position?: number
) {
  var nodesTmp = { ...nodes };
  if (position !== undefined) {
    if (nodesTmp[currentPathStr][position] === oldLabel) {
      nodesTmp[currentPathStr][position] = newLabel;
    }
  } else {
    const pos = nodesTmp[currentPathStr].indexOf(oldLabel);
    if (pos !== -1) {
      nodesTmp[currentPathStr][pos] = newLabel;
    }
  }
  return nodesTmp;
}



const SidebarEditCards: React.FC<SidebarEditCardsProps> = (props: SidebarEditCardsProps) => {

  const { lang, setClipboardCards } = useGlobalStore();
  const { nodes, l2Image, l2Audio, l2Visibility, l2Color, cachedLocalAutoL2image,
    setNodes, setL2Image, setL2Audio, setL2Visibility, setL2Color,
    setCachedLocalAutoL2image,
    takeSnapshot, resetSnapshot,
    addToHomeworks } = useTreeStore();
  const { visibleLabels, URLVars, getURLTo, setClipboardFromPath, addToPathMultipleChoices, removeFromPathMultipleChoices,
    checkIfCardIsInMultipleChoices } = useURLStore();
  const { selectedLabels, setSelectedLabels, resetSelectedLabels, addAllToSelectedLabels, selectedLabelsKeys } = useUIStore();
  const history = useHistory();
  const [isRecording, setIsRecording] = useState(false);
  const [visibleValue, setVisibleValue] = useState(true);
  const [showColorPalette, setShowColorPalette] = useState(false);
  const { takePhoto, photo, setPhoto } = usePhotoGallery();
  const [showEditOkBtn, setShowEditOkBtn] = useState(false);

  const [inputValue, setInputValue] = useState<string>("");
  const [showEditLabelPopover, setShowEditLabelPopover] = useState(false);
  const [playBtnContent, setPlayBtnContent] = useState<any>();
  const [showPlayBtn, setShowPlayBtn] = useState<boolean>(true);
  const inputRef = useRef<HTMLIonInputElement>(null);
  const [showToast, setShowToast] = useState(false);
  const [showDeletePopover, setShowDeletePopover] = useState(false);
  const [showSearchModal, setShowSearchModal] = useState(false);
  const [selectedImageSource, setSelectedImageSource] = useState<string | null>(null);
  const [isModalSelectorOpen, setIsModalSelectorOpen] = useState(false);
  const [isVideoPopoverOpen, setIsVideoPopoverOpen] = useState(false);
  const [expanded, setExpanded] = useState('cardsProps');
  const [doSetImage, setDoSetImage] = useState(false);
  const [deleteButtonsForPopover, setDeleteButtonsForPopover] = useState<any[]>([]);

  const { videoURL, setVideoURL } = useUIStore();


  /* USE EFFECT SNIPPET */
  useEffect(() => {
    if (showPlayBtn === true) {
      setPlayBtnContent(null);
    } else {
      setPlayBtnContent(<IonSpinner />);
    }

  }, [isRecording, showPlayBtn]);
  
  useEffect(() => {
    if (photo !== undefined) {
      if(doSetImage === false){
        addProperSuffixToSelectedLabels(); // 1. DO ALIASING
        setDoSetImage(true); // 2. SET NEXT STEP 
      }else if(doSetImage === true){  // 3. EXECUTE NEXT STEP 
        let updatedL2Image = { ...l2Image };
        selectedLabelsKeys.forEach(label => {
            updatedL2Image[label] = photo;
        });
        setL2Image(updatedL2Image);
      }
    }
}, [photo, doSetImage]);




  /* TEMPLATE FUNCTION(S) */
  const buttonTemplate = (onClick: any,
    icon: any, text: string,
    color: string = "light",
    className: string = "",
    alternativeIcon: any = null,
    fontSize = "18px") => <IonButton
      color={color}
      style={{ padding: 0, height: "60px", fontSize: fontSize}}
      expand='block'
      onClick={(event)=> {event.preventDefault(); onClick()}}
      className={className}
      
    >
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }}>
        {alternativeIcon === null ? <IonIcon size="large" icon={icon} /> : alternativeIcon}
        {text}
      </div>
    </IonButton>

  /* REF-BTN : ALL BUTTONS */

  /* REF-BTN: DELETE */
  enum DeletionType {
    Cards = 'Cards',
    Audio = 'Audio',
    Images = 'Images',
    All = 'All',
    NewLine = 'NewLine'
  };


  
  const handleDeletion = (deletionType: keyof typeof DeletionType) => {

    takeSnapshot(selectedLabelsKeys);
    setShowDeletePopover(false);
    let selectedLabelsPositions;
    switch (deletionType) {
      case DeletionType.Cards:
        selectedLabelsPositions = Object.values(selectedLabels).flat();
        setNodes(deleteNodesWithPrefix(
          deleteLabelsFromNodes(nodes, URLVars.nodePath!, selectedLabelsPositions),
          decodeURIComponent(URLVars.nodePath!),
          selectedLabelsKeys
        ));
        break;
  
      case DeletionType.Audio:
        setShowPlayBtn(false);
        let updatedL2Audio = { ...l2Audio };
        selectedLabelsKeys.forEach(label => delete updatedL2Audio[label]);
        setL2Audio(updatedL2Audio);
        setTimeout(() => setShowPlayBtn(true), 500);
        break;
  
      case DeletionType.Images:
        let updatedL2Image = { ...l2Image };
        selectedLabelsKeys.forEach(label => delete updatedL2Image[label]);
        setL2Image(updatedL2Image);
        break;

      case DeletionType.All:
        selectedLabelsPositions = Object.values(selectedLabels).flat();
        const newNodes = deleteNodesWithPrefix(
          deleteLabelsFromNodes(nodes, URLVars.nodePath!, selectedLabelsPositions),
          decodeURIComponent(URLVars.nodePath!),
          selectedLabelsKeys
        );

        const newL2Audio = { ...l2Audio };
        selectedLabelsKeys.forEach(label => delete newL2Audio[label]);

        const newL2Image = { ...l2Image };
        selectedLabelsKeys.forEach(label => delete newL2Image[label]);

        const newL2Color = { ...l2Color };
        selectedLabelsKeys.forEach(label => delete newL2Color[label]);

        const newL2Visibility = { ...l2Visibility };
        selectedLabelsKeys.forEach(label => delete newL2Visibility[label]);

        const newCachedLocalAutoL2image = { ...cachedLocalAutoL2image };
        selectedLabelsKeys.forEach(label => delete newCachedLocalAutoL2image[normalizeString(label)]);

        setNodes(newNodes);
        setL2Audio(newL2Audio);
        setL2Image(newL2Image);
        setL2Color(newL2Color);
        setL2Visibility(newL2Visibility);
        setCachedLocalAutoL2image(newCachedLocalAutoL2image);

        break;



    }
  
    resetSelectedLabels();
  };

  const handleDeleteBtn = () => {

    const deleteButtons = [
      {
        text: _dict.cardOnly[lang],
        handler: handleDeleteCardsOnly,
      },
      {
        text: _dict.recordedAudio[lang],
        handler: handleDeleteAudio,
      },
      {
        text: _dict.imagesOnly[lang],
        handler: handleDeleteImages,
      },
      {
        text: _dict.deleteAll[lang],
        handler: handleDeleteAll,
      }
    ];

    resetSnapshot();
    setDeleteButtonsForPopover(deleteButtons);
    setShowDeletePopover(true);
  }
  const deleteBtn = buttonTemplate(handleDeleteBtn, trash, _dict.deleteOptions[lang], "danger");
  const handleDeleteCardsOnly = () => handleDeletion(DeletionType.Cards);
  const handleDeleteAudio = () => handleDeletion(DeletionType.Audio);
  const handleDeleteImages = () => handleDeletion(DeletionType.Images);
  const handleDeleteAll = () => handleDeletion(DeletionType.All);
  const handleDeleteNewLine = () => handleDeletion(DeletionType.NewLine);

  /* REF-BTN: VISIBILITY */
  const handleVisibleBtn = () => {
    const { newSelectedLabels, newL2Visibility} = addProperSuffixToSelectedLabels();
    updateSimpleDictForKeys(newL2Visibility, Object.keys(newSelectedLabels), setL2Visibility, visibleValue);
    setVisibleValue(!visibleValue)
  }
  const visibleBtn = buttonTemplate(handleVisibleBtn, visibleValue ? eye : eyeOff, visibleValue ? _dict.show[lang] : _dict.hide[lang], "light");

  /* REF-BTN: GO TO / OPEN CARD */
  const handleGoBtn = () => {
    if (selectedLabelsKeys.length === 0) {
      return;
    }
    let nextFullPath = getURLTo().talkFromNextNodePath(selectedLabelsKeys[0]);
    let nextRelPath = URLVars.nodePath+_pathSeparator+selectedLabelsKeys[0];

    // Check if nextPath exist in nodes:
    if (nodes[nextRelPath] === undefined){
      setNodes({...nodes, [nextRelPath]: []});
    }
    history.push(nextFullPath);
    resetSelectedLabels();
  }
  const goBtn = buttonTemplate(handleGoBtn, enter, _dict.open[lang], "light");

  /* REF-BTN: COPY */
  const handleCopyBtn = () => {
    copyToClipboard(convertArrayToText(selectedLabelsKeys));
    setShowToast(true);
    setClipboardCards(selectedLabelsKeys);
    setClipboardFromPath();
    resetSelectedLabels();
  }
  const copyBtn = buttonTemplate(handleCopyBtn, copy, _dict.copy[lang]);


  /* REF-BTN: MOVE */
  /*const moveBtn = buttonTemplate(() => {
    props.setIsMoveMode(!props.isMoveMode);
  }, moveOutline, _dict.move[lang], props.isMoveMode ? 'warning' : 'light');*/

  /* REF-BTN: COLOR */
  const handleColorSelection = (color:string) => {
      const {newSelectedLabels, newL2Color} = addProperSuffixToSelectedLabels();
      updateSimpleDictForKeys(newL2Color, Object.keys(newSelectedLabels), setL2Color, color);
      setShowColorPalette(false);
  }

  const colorBtn = buttonTemplate(() => {
    setShowColorPalette(true);
  }, colorFillSharp, _dict.colorIt[lang], "", "multicolor-button");

  /* REF-BTN: MEDIA */
  const handlePicBtn = () => {
    setIsModalSelectorOpen(true);
  }
  const handleSelectorDismiss = (source: string | null) => {
    setIsModalSelectorOpen(false);
    if (source !== null) {
      if (source === "arasaac" || source === "unsplash") {
        setShowSearchModal(true);
      } else if (source === "device") {
        takePhoto();
      } else if (source === "youtube") {
        setIsVideoPopoverOpen(true)
      }
      setSelectedImageSource(source);
    }
  };

 
  const handleSearchModalDismiss = (image: string | null) => {
    
    if (image !== null) {
      setPhoto(image);
    }
    setShowSearchModal(false);
    //setSelectedImageSource(null);
    //resetSelectedLabels();
  };
  const handleVideoConfirm = (url: string | null) => {
    setIsVideoPopoverOpen(false);
    if (url === null) return;
    
    const updatedL2Image = { ...l2Image };
    selectedLabelsKeys.forEach((labelKey) => {
      updatedL2Image[labelKey] = url;
    });
    
    setL2Image(updatedL2Image);
  };
  const picBtn = buttonTemplate(handlePicBtn, image, _dict.chooseImage[lang]);

  /* REF-BTN: EDIT TEXT */
  const updateLabelInDictionaries = (
    oldLabel: string,
    newLabel: string,
    dictionaries: { [key: string]: any }[],
    deleteOld: boolean = false

  ): { [key: string]: any }[] => {
    return dictionaries.map(dict => {
      const updatedDict = { ...dict };
      if (dict[oldLabel]) {
        updatedDict[newLabel] = dict[oldLabel];
        if(deleteOld === true){
          // usually should NOT delete otherwise other cards with the same label will be affected
          // one exception is for selected labels dict
          delete updatedDict[oldLabel]; 
        }
      }
      return updatedDict;
    });
  };

  // ALIASING ALL SELECTED LABELS
  const addProperSuffixToSelectedLabels = (defaultLabel?: string | undefined, suffixDict?: { [key: string]: string } | undefined) => {
    let newNodes = { ...nodes };
    let newL2Image = { ...l2Image };
    let newL2Audio = { ...l2Audio };
    let newL2Visibility = { ...l2Visibility };
    let newL2Color = { ...l2Color };
    let newSelectedLabels = { ...selectedLabels };
    let newCachedLocalAutoL2image = { ...cachedLocalAutoL2image }; // Add this line
    let labelsToAddToMultipleChoices = []
    let labelsToRemoveFromMultipleChoices = []

    if (suffixDict === undefined) {
      suffixDict = getProperSuffixDict(nodes, selectedLabelsKeys);
    }

    for (const prevLabel of selectedLabelsKeys) {
      //const newLabel = suffixDict === undefined ? defaultLabel : prevLabel.replaceAll(_ALIAS_SUFFIX, "") + (suffixDict[prevLabel] || "");
      const newLabel = defaultLabel || prevLabel.replaceAll(_ALIAS_SUFFIX, "") + (suffixDict?.[prevLabel] || "");


      for (const prevPosition of selectedLabels[prevLabel]) {
        newNodes = changeLabelInNodes(newNodes, URLVars.nodePath!, prevLabel, newLabel || prevLabel, prevPosition);
      }

      let dictionaries = [newL2Image, newL2Audio, newL2Visibility, newL2Color];
      [newL2Image, newL2Audio, newL2Visibility, newL2Color] = updateLabelInDictionaries(prevLabel, newLabel || prevLabel, dictionaries);
      newCachedLocalAutoL2image = updateLabelInDictionaries(normalizeString(prevLabel), normalizeString(newLabel || prevLabel), [newCachedLocalAutoL2image])[0];
      newSelectedLabels = updateLabelInDictionaries(prevLabel, newLabel || prevLabel, [newSelectedLabels], true)[0];


      if(checkIfCardIsInMultipleChoices(prevLabel)){
        labelsToAddToMultipleChoices.push(newLabel || prevLabel);
        labelsToRemoveFromMultipleChoices.push(prevLabel);
      }      
      

    }
    
    setNodes(newNodes);
    setL2Image(newL2Image);
    setL2Audio(newL2Audio);
    setL2Visibility(newL2Visibility);
    setL2Color(newL2Color);
    setCachedLocalAutoL2image(newCachedLocalAutoL2image); // Add this line
    setSelectedLabels(newSelectedLabels);
    removeFromPathMultipleChoices(labelsToRemoveFromMultipleChoices);
    addToPathMultipleChoices(labelsToAddToMultipleChoices);

    return { newNodes, newL2Image, newL2Audio, newL2Visibility, newL2Color, newCachedLocalAutoL2image, newSelectedLabels };
  };
  
  const handleOnClickEditOkBtn = (suffixDict: { [key: string]: string } | undefined = undefined) => {
    let currLabel = inputRef.current?.value?.toLocaleString() || "";

    

    addProperSuffixToSelectedLabels(currLabel, suffixDict);
        
    setShowEditOkBtn(false);
    setShowEditLabelPopover(false);
    resetSelectedLabels();
  };
  
  const inputStyle = {
    fontSize: '24px',
    height: '80px',
    backgroundColor: '#f4f4f4',
    borderRadius: '5px',
    padding: '10px',
    textAlign: 'center',
    overflow: "hidden"
  };
  const editLabelPopoverStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center'
  };
  const editLabelBtn = buttonTemplate(() => {
    setShowEditLabelPopover(true);
    inputRef.current?.setFocus();
  }, textOutline, _dict.editText[lang]);
  const handleKeyDown = (e: any) => {
    if (e.key === 'Enter') {
      handleOnClickEditOkBtn();
    }
  };
  const editableText = <IonInput style={inputStyle} ref={inputRef}
    onKeyDown={handleKeyDown}
    value={charsMappingFromURL(inputValue)}
  ></IonInput>;
  const editOkBtn = <IonCardTitle className="ion-text-center">
    <IonButton onClick={() => handleOnClickEditOkBtn()} expand="full" color="light">
      <IonIcon icon={checkmark} size="small" slot="start" />
    </IonButton>
  </IonCardTitle>;


  /* REF-BTN: CACHED IMAGES */
  const handleCachedPicsBtnClick = () => {
    let { newL2Image, newCachedLocalAutoL2image, newSelectedLabels  } = addProperSuffixToSelectedLabels();
    const newSelectedLabelsKeys = Object.keys(newSelectedLabels);
    newSelectedLabelsKeys.forEach((labelKey) => {
      const cachedArray = newCachedLocalAutoL2image[normalizeString(labelKey)];
      if(cachedArray !== undefined && cachedArray.length > 1){
        const numberOfCachedPics = cachedArray?.length;
        if (numberOfCachedPics > 1) {
          const shiftedArray = [...cachedArray.slice(1), cachedArray[0]];
          newL2Image = updict(newL2Image, labelKey, shiftedArray[0]);
          newCachedLocalAutoL2image = updict(newCachedLocalAutoL2image, normalizeString(labelKey), shiftedArray);
        }
      }
    });
    setL2Image(newL2Image);
    setCachedLocalAutoL2image(newCachedLocalAutoL2image);
  }
  const cachedPicsBtn = buttonTemplate(handleCachedPicsBtnClick, shapes, _dict.nextImage[lang]);

  /* REF-BTN: PLAY */
  const handlePlaySound = async () => {
    for (const labelKey of selectedLabelsKeys) {
      // Skip special cards
      if (charsMappingFromURL(labelKey.replaceAll(_ALIAS_SUFFIX, "")) !== labelKey.replaceAll(_ALIAS_SUFFIX, "")) {
        continue;
      }
      
      // Play audio if available
      if (l2Audio.hasOwnProperty(labelKey)) {
        await new Promise(resolve => {
          const audioRef = new Audio(`data:${l2Audio[labelKey].mimeType};base64,${l2Audio[labelKey].base64}`);
          audioRef.onended = resolve;
          audioRef.play();
        });
      } else if (isYoutubeUrl(l2Image[labelKey])) {
        // Handle YouTube URL without waiting
        setVideoURL(l2Image[labelKey]);
        // Assuming playing YouTube video is handled elsewhere and doesn't require sequential play
        break;
      }

    }
  };
  
  const playBtn = buttonTemplate(isRecording ? undefined : async () => { await handlePlaySound() }, playCircle, _dict.playSound[lang], "light", "", playBtnContent);

  /* REF-BTN: RECORD */
  const handleRecordingComplete = (sound: Sound) => {
    setIsRecording(false);
    setShowPlayBtn(true);

    const updatedL2Audio = { ...l2Audio };
    selectedLabelsKeys.forEach((labelKey) => {
      updatedL2Audio[labelKey] = sound;
    });
    setL2Audio(updatedL2Audio);
  };
  
  const handleRecordClick = () => {
    setShowPlayBtn(false);
  };
  const recordBtn = <div onClick={handleRecordClick} style={{ padding: 0, height: "60px" }}>
      <VoiceRecorder
        lang={lang}
        onRecordingComplete={handleRecordingComplete}
        style={{ padding: 0, height: "60px" }}
      />
    </div>;
  
  /* REF-BTN: MULTIPLE CHOICE */
  const cardsAsMultipleChoiceBtn = buttonTemplate(
    () => {
      const { newSelectedLabels } = addProperSuffixToSelectedLabels();
      addToPathMultipleChoices(Object.keys(newSelectedLabels));
    },
    gameController,
    _dict.cardsAsMultipleChoice[lang],
    "light",
    "",
    null,
    "14px"
  );
  const cardsNotAsMultipleChoiceBtn = buttonTemplate(
    () => {
      const { newSelectedLabels } = addProperSuffixToSelectedLabels();
      removeFromPathMultipleChoices(Object.keys(newSelectedLabels));
    },
    gameController,
    _dict.cardsNotAsMultipleChoice[lang],
    "light",
    "",
    null,
    "14px"
  );


  /* REF-BTN: Add to homework */
  const addToHomeworksBtn = buttonTemplate(
    () => {
      addToHomeworks([URLVars.nodePath+_pathSeparator+Object.keys(selectedLabels)]);
      history.push(getURLTo().homeworks());
    },
    schoolOutline,
    _dict.addToHomeworks[lang],
    "light",
    "",
    null,
    "14px"
  );
  


  const handlePopoverDidPresent = () => {
    if (inputRef.current) {
      inputRef.current.setFocus();
    }
  };


  /*const selectAllBtn = (selectAll: boolean) => {
    return buttonTemplate(
      selectAll ? () => { addAllToSelectedLabels(visibleLabels); } : () => { resetSelectedLabels(); },
      selectAll ? checkmarkDoneCircleSharp : closeCircleSharp,
      selectAll ? _dict.selectAll[lang] : _dict.unselectAll[lang],
      "clear",
      "100%",
      null
    );
  }*/



   
  
  
  




  return (
    <>
      <IonCol
        size="3"
        style={{
          overflowY: 'scroll',
          maxHeight: '100vh',
          minHeight: '100vh',
          maxWidth: '300px',
          minWidth: '204px',
          scrollbarWidth: 'none',
          msOverflowStyle: 'none',
          backgroundColor: '#333333',
          padding: 0,
          margin: 0,


        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',

          }}
        >
          
          <div className="container">
            <IonGrid style={{ padding: 0, margin: 0, }}>
              
              <IonRow>
              {selectedLabelsKeys.length === 1 && <IonCol>{goBtn}</IonCol>}
                <IonCol>{deleteBtn}</IonCol>
                
              </IonRow>
              
              <IonAccordionGroup 
              
              value={expanded} onIonChange={e => setExpanded(e.detail.value)}>
              <IonAccordion value="cardsProps" style={{ backgroundColor: 'transparent' }}>
              <IonItem
              lines='none'
              slot="header" style={{
                backgroundColor: 'white', // Embracing the white background
                borderRadius: '8px', // Rounded corners
                margin: '10px', // Margin for spacing
                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)', // Soft shadow for depth
                padding: '15px', // Increased padding for a larger touch area
                border: '1px solid #e0e0e0', // Subtle border for definition
                alignItems: 'center', // Align items for a neat layout
                display: 'flex', // Ensure flex layout for alignment
                justifyContent: 'flex-start', // Align content to the start
                fontWeight: 500, // Increased font weight for readability
              }}>
                <IonIcon icon={albumsOutline} slot="start" style={{ marginRight: '10px' }} /> {/* Icon added */}
                <IonLabel color="dark" >{_dict.cardsProps[lang]}</IonLabel>
                </IonItem>
              <IonGrid slot="content" style={{ backgroundColor: 'transparent' }} >
              

              <IonRow>
                <IonCol>{editLabelBtn}</IonCol>
              </IonRow>
              <IonRow>
                <IonCol>{copyBtn}</IonCol>
                {/*<IonCol>{moveBtn}</IonCol>*/}
              </IonRow>

              <IonRow>
                <IonCol>{colorBtn}</IonCol>
                <IonCol>{visibleBtn}</IonCol>
              </IonRow>

              <IonRow>
                <IonCol>{picBtn}</IonCol>
                <IonCol>{cachedPicsBtn}</IonCol>
              </IonRow>
              <IonRow>
                <IonCol>{playBtn}</IonCol>
                <IonCol>{recordBtn}</IonCol>
              </IonRow>
              </IonGrid>
              </IonAccordion>
              <IonAccordion value="cardsActivities" style={{ backgroundColor: 'transparent' }}>
              <IonItem slot="header" lines='none' style={{
                backgroundColor: 'white', // Embracing the white background
                borderRadius: '8px', // Rounded corners
                margin: '10px', // Margin for spacing
                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)', // Soft shadow for depth
                padding: '15px', // Increased padding for a larger touch area
                border: '1px solid #e0e0e0', // Subtle border for definition
                alignItems: 'center', // Align items for a neat layout
                display: 'flex', // Ensure flex layout for alignment
                justifyContent: 'flex-start', // Align content to the start
                fontWeight: 500, // Increased font weight for readability
              }}>
                  <IonIcon icon={gameControllerOutline} slot="start" style={{ marginRight: '10px' }} /> {/* Different icon */}
            <IonLabel color="dark">{_dict.cardsActivities[lang]}</IonLabel>
          </IonItem>
                <IonGrid slot="content">
                {/*<IonRow>
                  <IonCol>{cardsAsMultipleChoiceBtn}</IonCol>
                  <IonCol>{cardsNotAsMultipleChoiceBtn}</IonCol>
            </IonRow>*/}
                <IonRow>
                  <IonCol>{addToHomeworksBtn}</IonCol>
                </IonRow>
              </IonGrid>
            </IonAccordion>
            </IonAccordionGroup>
            </IonGrid>
            </div>
        </div>







      </IonCol>
      <IonPopover isOpen={showColorPalette} onDidDismiss={() => setShowColorPalette(false)}>
        <div style={{}}>
          {_possibleCardColors.map((color) => (
            <div
              key={color}
              onClick={() => handleColorSelection(color)}
              style={{
                backgroundColor: color,

                height: '50px',
                margin: '5px',
                cursor: 'pointer',
                border: '1px solid #333333'
              }}
            ></div>
          ))}
        </div>
      </IonPopover>




      <IonPopover
        isOpen={showEditLabelPopover}
        style={editLabelPopoverStyle}
        onDidDismiss={() => setShowEditLabelPopover(false)}
        onDidPresent={handlePopoverDidPresent}
      >
        {editableText}
        {showEditOkBtn ? editOkBtn : null}
      </IonPopover>
      <IonToast
        isOpen={showToast}
        onDidDismiss={() => setShowToast(false)}
        message={_dict.pathCopied[lang]}
        position="top"
        duration={2000}
      />
      <IonActionSheet
        isOpen={showDeletePopover}
        onDidDismiss={() => setShowDeletePopover(false)}
        header={_dict.delete[lang] + '?'}
        buttons={
          deleteButtonsForPopover
        }
      ></IonActionSheet>


      {selectedImageSource !== null ? <SearchModal
        isOpen={showSearchModal}
        lang={lang}
        onDidDismiss={handleSearchModalDismiss}
        where={selectedImageSource}
      /> : null}
      <ImageSelector
        isOpen={isModalSelectorOpen}
        onDidDismiss={handleSelectorDismiss}
        lang={lang}
      />
      <VideoPopover isOpen={isVideoPopoverOpen} onConfirm={handleVideoConfirm} lang={lang} />
    </>
  );
};

export default SidebarEditCards;
